import React from 'react';
import PropTypes from 'prop-types';

import {
    RIQPopover
} from '../RIQPopover.jsx';

MetricTableProgressBarCell.propTypes = {
    abbreviatedValue: PropTypes.string.isRequired,
    expandedValue: PropTypes.string.isRequired,
    metricName: PropTypes.string,
    rawValue: PropTypes.number,
    maxValue: PropTypes.number
};

export default function MetricTableProgressBarCell({abbreviatedValue, expandedValue, metricName, rawValue, maxValue, valueClassName}) {

    const progressBarPct = Math.max(100 * (rawValue && maxValue ? rawValue / maxValue : 0), 0);


    const tableCellNode = (
        <>
            {/* progress bar */}
            <div className='tlw-flex tlw-h-10 tlw-grow tlw-items-center'>
                <div className='tlw-w-full tlw-overflow-hidden tlw-rounded-[10px] tlw-bg-gray-150'>
                    <div
                        className='tlw-h-4 !tlw-bg-gray-800'
                        style={{
                            width: `${progressBarPct}%`
                        }}>
                    </div>
                </div>
            </div>

            {/* value */}
            <div className={valueClassName}>
                {abbreviatedValue}
            </div>
        </>
    );

    return (
        <td
            className='tlw-p-4'>
            <RIQPopover
                triggerNode={tableCellNode}
                additionalHookProps={{
                    delayShow: RIQPopover.StandardDelayMS
                }}
                className='tlw-flex tlw-w-full tlw-items-center tlw-text-md tlw-font-normal tlw-text-gray-900'
            >
                <div className='tlw-px-7 tlw-py-4.5'>
                    <div
                        className='tlw-text-11 tlw-font-semibold tlw-uppercase tlw-text-gray-700'>
                        {metricName}
                    </div>
                    <div
                        className='tlw-text-xl tlw-font-bold tlw-leading-36 tlw-text-gray-900'>
                        {expandedValue}
                    </div>
                </div>
            </RIQPopover>
        </td>
    );
}
